var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-wrapper"},[_c('div',{staticClass:"notification-top"},[_c('h4',[_vm._v("Notifications")]),_c('router-link',{staticClass:"m-0",attrs:{"to":"/notifications"}},[_vm._v("View all")])],1),_c('NotificationContent',{attrs:{"notificationList":_vm.notificationList,"showLoader":_vm.showLoader}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }